// Whether a click on a link starts a page change the top progress bar should show (components/v9/RouteProgress.tsx).
// The click's defaultPrevented says nothing here: next/link prevents the default of every click it handles. A control
// inside a link that does something else (the photo zoom on a bundle card) stops the click's propagation instead, and
// the listener, on the window, never sees it.

type LinkLike = { href: string; target: string; download: boolean };
type ClickLike = { button: number; metaKey: boolean; ctrlKey: boolean; shiftKey: boolean; altKey: boolean };

export function isPageNavigation(a: LinkLike, e: ClickLike, currentHref: string): boolean {
  if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return false;
  if (a.target && a.target !== '_self') return false;
  if (a.download) return false;
  let to: URL, here: URL;
  try { to = new URL(a.href, currentHref); here = new URL(currentHref); } catch { return false; }
  if (to.origin !== here.origin) return false;
  // Same page (an anchor inside it, or the link to where we are): nothing loads.
  return to.pathname !== here.pathname || to.search !== here.search;
}
